export * from './PrismicRichText';
